import { formatDate, formatMoney, toDateInput } from './reports.utils'

export function buildRows(reportCases, users) {
    // Build user lookup map
    const userMap = {}
    ;(Array.isArray(users) ? users : []).forEach(u => {
        if (u?._id) userMap[u._id] = u
    })

    // 🔑 Correctly extract rows from Redux shape
    const rows = Array.isArray(reportCases?.items)
        ? reportCases.items
        : Array.isArray(reportCases)
            ? reportCases
            : []

    const now = new Date()
    now.setHours(0, 0, 0, 0)

    return rows.map(r => {
        const picObj =
            r.personInCharge && typeof r.personInCharge === 'object'
                ? r.personInCharge
                : null

        const picId = picObj?._id || r.personInCharge
        const picUser = picId ? userMap[picId] : null

        return {
            ...r,
            _id: r._id, // explicit for DataGrid

            personInChargeName:
                picObj?.name ||
                picUser?.name ||
                picUser?.email ||
                '-',

            emailReceivedOnFmt: formatDate(r.emailReceivedOn),
            dueDateFmt: formatDate(r.dueDate),
            sentToClientDateFmt: formatDate(r.sentToClientDate),
            signedReceivedDateFmt: formatDate(r.signedReceivedDate),

            nextFollowUpDate: toDateInput(r.nextFollowUpDate),
            totalOutstandingFmt: formatMoney(r.totalOutstanding),

            isUrgent: r.isUrgent
        }
    })
}